(function () {
  if (window.__orionPersonalizerCartSyncInitialized) {
    return;
  }
  window.__orionPersonalizerCartSyncInitialized = true;

  // ---------------------------------------------------------------------------
  // Sync des lignes de frais de personnalisation (Shopify Basic workaround)
  // ---------------------------------------------------------------------------
  // Objectif:
  // - garder le bon total panier quand les quantités changent après ajout au panier
  // - resynchroniser les lignes techniques "1€" et "0,01€" par groupe personnalisé
  //
  // Limite assumée:
  // - ce n'est pas du pricing natif Shopify (pas de Plus / Cart Transform)
  // - on maintient des lignes techniques invisibles côté UI
  // ---------------------------------------------------------------------------
  var FEE_VARIANT_ONE_EURO = '56840121876828';
  var FEE_VARIANT_ONE_CENT = '56840121909596';
  var syncTimer = null;
  var syncInFlight = false;
  var syncInFlightPromise = null;
  var feeProductCacheByTechnique = {};
  var initialReadyPromise = null;

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
      ? window.Shopify.routes.root
      : '/';
  }

  function toInt(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? Math.round(parsed) : fallback;
  }

  function resolveCustomGroupId(groupId, group) {
    var collections = [];
    if (group && Array.isArray(group.products)) collections.push(group.products);
    if (group && Array.isArray(group.fees)) collections.push(group.fees);
    for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex += 1) {
      var entries = collections[collectionIndex];
      for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
        var entry = entries[entryIndex];
        var props = entry && entry.props ? entry.props : {};
        var customGroupId = String(props._custom_group_id || '').trim();
        if (customGroupId) return customGroupId;
      }
    }
    return String(groupId || '');
  }

  function parseLineProperties(line) {
    var props = {};
    if (!line || !line.properties) return props;
    Object.keys(line.properties).forEach(function (key) {
      props[String(key)] = line.properties[key];
    });
    return props;
  }

  function parseJsonSafe(value, fallback) {
    try {
      return JSON.parse(String(value || ''));
    } catch (error) {
      return fallback;
    }
  }

  function isFeeLine(line) {
    var props = parseLineProperties(line);
    return String(props._personalization_fee || '').toLowerCase() === 'true';
  }

  function isTechniqueFeeLine(lineOrEntry) {
    var sourceLine = lineOrEntry && lineOrEntry.line ? lineOrEntry.line : lineOrEntry;
    var props = parseLineProperties(sourceLine);
    var technique = String(props._selected_technique || '').toLowerCase();
    if (technique.indexOf('brod') >= 0 || technique.indexOf('floc') >= 0) return true;
    return !!String(props._fee_zone_label || '').trim();
  }

  function isPrintOptionLine(lineOrEntry) {
    var sourceLine = lineOrEntry && lineOrEntry.line ? lineOrEntry.line : lineOrEntry;
    var props = parseLineProperties(sourceLine);
    return String(props._print_option || '').toLowerCase() === 'true' || props._orion_line_role === 'print_option';
  }

  function getPrintOptionQuantityMode(lineOrEntry) {
    var sourceLine = lineOrEntry && lineOrEntry.line ? lineOrEntry.line : lineOrEntry;
    var props = parseLineProperties(sourceLine);
    return String(props._print_option_quantity_mode || '').toLowerCase() === 'fixed' ? 'fixed' : 'per_unit';
  }

  function isPersonalizedProductLine(line) {
    var props = parseLineProperties(line);
    return !!(props._custom_group_id || props._personalization_group) && !isFeeLine(line) && String(props._personalized_product || '').toLowerCase() === 'true';
  }

  function normalizeTechniqueKey(value) {
    var technique = String(value || '').toLowerCase();
    if (technique.indexOf('brod') >= 0) return 'broderie';
    if (technique.indexOf('floc') >= 0) return 'flocage';
    return '';
  }

  function getTechniqueKeyForGroup(group) {
    var products = group && group.products ? group.products : [];
    for (var i = 0; i < products.length; i += 1) {
      var props = products[i] && products[i].props ? products[i].props : {};
      var techniqueKey = normalizeTechniqueKey(props._selected_technique);
      if (techniqueKey) return techniqueKey;
    }
    return '';
  }

  function normalizeFeeZoneKey(value) {
    var text = String(value || '').trim().toLowerCase();
    if (!text) return '';
    if (text.indexOf('anti') >= 0 && text.indexOf('coeur') >= 0) return 'anti-coeur';
    if (text.indexOf('avant') >= 0 && text.indexOf('a3') >= 0) return 'front-a3';
    if (text.indexOf('avant') >= 0 && text.indexOf('a4') >= 0) return 'front-a4';
    if (text.indexOf('dos') >= 0 && text.indexOf('a3') >= 0) return 'back-a3';
    if (text.indexOf('dos') >= 0 && text.indexOf('a4') >= 0) return 'back-a4';
    if (text.indexOf('front-a3') >= 0) return 'front-a3';
    if (text.indexOf('front-a4') >= 0) return 'front-a4';
    if (text.indexOf('back-a3') >= 0) return 'back-a3';
    if (text.indexOf('back-a4') >= 0) return 'back-a4';
    if (text.indexOf('coeur') >= 0) return 'coeur';
    if (text.indexOf('dos') >= 0 || text.indexOf('back') >= 0) return 'dos';
    if (text.indexOf('col') >= 0) return 'col';
    return '';
  }

  function getExpectedFeeZoneKeysForGroup(group) {
    var zones = [];
    (group && group.products || []).forEach(function (entry) {
      var props = entry && entry.props ? entry.props : {};
      var exactZones = parseJsonSafe(props._selected_zones, null);
      if (Array.isArray(exactZones)) {
        exactZones.forEach(function (zoneId) { var key = normalizeFeeZoneKey(zoneId); if (key) zones.push(key); });
        return;
      }
      var batPayload = parseJsonSafe(props._bat_payload, null);
      var batEntries = batPayload && Array.isArray(batPayload.grouped_entries) ? batPayload.grouped_entries : [];
      if (batEntries.length) {
        batEntries.forEach(function (batEntry) {
          var batZoneId = String(batEntry && batEntry.zoneId || '').trim();
          var batZoneLabel = String(batEntry && batEntry.zoneLabel || '').trim();
          var normalizedBatZone = normalizeFeeZoneKey(batZoneLabel || batZoneId);
          if (normalizedBatZone) zones.push(normalizedBatZone);
        });
        return;
      }
      var personalizationSummary = String(props.personnalisation || '').trim();
      if (personalizationSummary) {
        personalizationSummary.split(/\s*\/\s*/).forEach(function (summaryPart) {
          var normalizedSummaryZone = normalizeFeeZoneKey(summaryPart);
          if (normalizedSummaryZone) zones.push(normalizedSummaryZone);
        });
      }
      var selectedZones = parseJsonSafe(props._selected_zones, null);
      if (Array.isArray(selectedZones)) {
        selectedZones.forEach(function (zoneId) {
          var value = normalizeFeeZoneKey(zoneId);
          if (value) zones.push(value);
        });
        return;
      }
      var selectedZone = normalizeFeeZoneKey(props._selected_zone || '');
      if (selectedZone) zones.push(selectedZone);
    });
    return Array.from(new Set(zones));
  }

  function getFeeZoneKey(entry) {
    var entryProps = entry && entry.props ? entry.props : {};
    return normalizeFeeZoneKey(entryProps._fee_zone_label || entryProps._selected_zone || '');
  }

  function parseFeeVariantDiscountPercent(value) {
    var match = String(value || '')
      .replace(/[–—−]/g, '-')
      .match(/(?:^|[^\d])(\d{1,3})\s*%/);
    if (!match) return 0;
    return Math.max(0, Math.round(Number(match[1]) || 0));
  }

  // Groupe les lignes panier pour recalculer les frais par `_personalization_group`.
  function buildGroups(cart) {
    var groups = {};
    (cart.items || []).forEach(function (line, index) {
      var props = parseLineProperties(line);
      var groupId = String(props._custom_group_id || props._personalization_group || '');
      if (!groupId) return;

      if (!groups[groupId]) {
        groups[groupId] = { products: [], fees: [], totalQty: 0 };
      }

      var entry = {
        line: line,
        lineNumber: index + 1,
        lineKey: String(line.key || ''),
        props: props,
      };

      if (isFeeLine(line)) {
        groups[groupId].fees.push(entry);
        return;
      }

      if (isPersonalizedProductLine(line)) {
        groups[groupId].products.push(entry);
        groups[groupId].totalQty += Math.max(0, toInt(line.quantity, 0) || 0);
      }
    });
    return groups;
  }

  // Recalcule le montant de frais attendu pour un groupe donné selon les règles pricing.
  // Le résultat correspond à: (prix personnalisé - prix produit Shopify) * quantités.
  function computeDesiredFeeCentsForGroup(group) {
    if (!group || !group.products || !group.products.length) return 0;
    var qty = Math.max(1, toInt(group.totalQty, 1) || 1);

    var feeTotal = group.products.reduce(function (total, entry) {
      var props = entry.props || {};
      var basePriceCents = Math.max(0, toInt(props._pz_base_price_cents, toInt(entry.line && entry.line.price, 0) || 0) || 0);
      var techniquePriceCents = Math.max(0, toInt(props._pz_technique_price_cents, 0) || 0);
      var zonePriceCents = Math.max(0, toInt(props._pz_zone_price_cents, 0) || 0);
      var lineQty = Math.max(0, toInt(entry.line && entry.line.quantity, 0) || 0);
      var unitAfterDiscount = basePriceCents + techniquePriceCents + zonePriceCents;

      // Force integer cents to avoid float artifacts (e.g. 0.999999 => extra 1 cent line).
      var unitFee = Math.max(0, Math.round(Number(unitAfterDiscount) - Number(basePriceCents)));
      return total + unitFee * lineQty;
    }, 0);
    return Math.max(0, Math.round(Number(feeTotal) || 0));
  }

  function currentFeeTotals(group) {
    var result = { euroLine: null, centLine: null };
    (group.fees || []).forEach(function (entry) {
      var variantId = String(entry.line && (entry.line.variant_id || entry.line.id) || '');
      if (variantId === FEE_VARIANT_ONE_EURO) result.euroLine = entry;
      if (variantId === FEE_VARIANT_ONE_CENT) result.centLine = entry;
    });
    return result;
  }

  function getLineUnitPriceCents(lineOrEntry) {
    var line = lineOrEntry && lineOrEntry.line ? lineOrEntry.line : lineOrEntry;
    if (!line) return 0;
    var directPrice = toInt(line.price, NaN);
    if (Number.isFinite(directPrice)) return Math.max(0, directPrice);
    var finalPrice = toInt(line.final_price, NaN);
    if (Number.isFinite(finalPrice)) return Math.max(0, finalPrice);
    var originalPrice = toInt(line.original_price, 0);
    return Math.max(0, originalPrice);
  }

  function buildBroderieFeePlan(entries, totalQty, desiredFeeCents) {
    var broderieEntries = Array.isArray(entries) ? entries.filter(Boolean) : [];
    var maxQty = Math.max(0, toInt(totalQty, 0) || 0);
    var targetTotal = Math.max(0, toInt(desiredFeeCents, 0) || 0);
    if (!broderieEntries.length || !maxQty) {
      return {
        lineQuantities: {},
        euroQty: Math.floor(targetTotal / 100),
        centQty: targetTotal % 100
      };
    }

    var entryMeta = broderieEntries.map(function (entry) {
      var unitPrice = Math.max(0, getLineUnitPriceCents(entry));
      return {
        entry: entry,
        unitPrice: unitPrice,
        nominalTotal: unitPrice * maxQty
      };
    });

    var totalNominal = entryMeta.reduce(function (sum, item) {
      return sum + Math.max(0, item.nominalTotal || 0);
    }, 0);

    if (!totalNominal) {
      return {
        lineQuantities: {},
        euroQty: Math.floor(targetTotal / 100),
        centQty: targetTotal % 100
      };
    }

    var remainingDesired = targetTotal;
    var remainingNominal = totalNominal;
    var lineQuantities = {};

    entryMeta.forEach(function (item, index) {
      var key = String((item.entry && item.entry.lineKey) || (item.entry && item.entry.lineNumber) || '');
      if (!key || !(item.unitPrice > 0)) {
        if (key) lineQuantities[key] = 0;
        remainingNominal -= Math.max(0, item.nominalTotal || 0);
        return;
      }

      var targetLineCents = 0;
      if (index === entryMeta.length - 1 || remainingNominal <= 0) {
        targetLineCents = remainingDesired;
      } else {
        targetLineCents = Math.round(remainingDesired * (item.nominalTotal / remainingNominal));
      }
      targetLineCents = Math.max(0, Math.min(remainingDesired, targetLineCents));

      var targetQty = Math.floor(targetLineCents / item.unitPrice);
      targetQty = Math.max(0, Math.min(maxQty, targetQty));

      lineQuantities[key] = targetQty;
      remainingDesired -= targetQty * item.unitPrice;
      remainingDesired = Math.max(0, remainingDesired);
      remainingNominal -= Math.max(0, item.nominalTotal || 0);
    });

    return {
      lineQuantities: lineQuantities,
      euroQty: Math.floor(remainingDesired / 100),
      centQty: remainingDesired % 100
    };
  }

  function cartFetchJson(path, options) {
    return fetch(path, options).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + String(response.status || 0));
      return response.json();
    });
  }

  function getFeeProductHandlesForTechnique(techniqueKey) {
    if (techniqueKey === 'broderie') return ['frais-broderie', 'frais-de-personnalisation'];
    if (techniqueKey === 'flocage') return ['frais-flocage'];
    return [];
  }

  function fetchFeeProductForTechnique(techniqueKey) {
    if (!techniqueKey) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(feeProductCacheByTechnique, techniqueKey)) {
      return Promise.resolve(feeProductCacheByTechnique[techniqueKey]);
    }
    var handles = getFeeProductHandlesForTechnique(techniqueKey);
    var chain = Promise.resolve(null);
    handles.forEach(function (handle) {
      chain = chain.then(function (product) {
        if (product) return product;
        return cartFetchJson(getRoutesRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' }
        }).catch(function () {
          return null;
        });
      });
    });
    return chain.then(function (product) {
      feeProductCacheByTechnique[techniqueKey] = product || null;
      return feeProductCacheByTechnique[techniqueKey];
    });
  }

  function findBaseFeeVariantForZone(techniqueKey, zoneKey) {
    var wantedKey = normalizeFeeZoneKey(zoneKey);
    if (!wantedKey) return Promise.resolve(null);
    return fetchFeeProductForTechnique(techniqueKey).then(function (product) {
      var variants = Array.isArray(product && product.variants) ? product.variants : [];
      // Les variantes remisées de frais ne sont plus utilisées ; la remise est désormais gérée par la Discount Function Shopify.
      var baseVariant = variants.find(function (item) {
        var title = String(item && item.title ? item.title : '');
        return (
          normalizeFeeZoneKey(title) === wantedKey &&
          !/\d{1,3}\s*%/.test(title)
        );
      });
      return baseVariant || null;
    });
  }

  // Batch update des lignes (plus fiable que plusieurs cart/change.js successifs).
  function updateLines(updates) {
    var body = JSON.stringify({ updates: updates || {} });
    return cartFetchJson(getRoutesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
    });
  }

  // Ajoute une ligne de frais technique (1€ ou 0,01€) liée au groupe.
  function addFeeLine(variantId, quantity, groupId, customGroupId) {
    if (!variantId || quantity <= 0) return Promise.resolve();
    var body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: {
        ligne: 'Frais de personnalisation',
        // Les lignes de frais recreees partagent le meme group id que le bloc personnalise source.
        _custom_group_id: String(customGroupId || groupId || ''),
        _personalization_fee: 'true',
      },
    });
    return cartFetchJson(getRoutesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
    });
  }

  function addTechniqueFeeLine(variantId, quantity, groupId, customGroupId, techniqueKey, zoneKey) {
    if (!variantId || quantity <= 0 || !groupId || !techniqueKey) return Promise.resolve();
    var body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: {
        ligne: 'Frais de personnalisation',
        _custom_group_id: String(customGroupId || groupId || ''),
        _personalization_fee: 'true',
        _selected_technique: techniqueKey,
        _selected_zone: String(zoneKey || ''),
        _fee_zone_label: String(zoneKey || '')
      }
    });
    return cartFetchJson(getRoutesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body,
    });
  }

  // Notifie le thème qu'un update panier a eu lieu pour déclencher rerender sections/UI custom.
  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'personalizer-cart-sync', cartData: cartData || null });
      return;
    }
    window.location.reload();
  }

  // Synchronisation immédiate des frais techniques:
  // - supprime les frais orphelins
  // - ajuste / ajoute les lignes 1€ et 0,01€
  // - republie un événement panier si des opérations ont été faites
  function syncFeesNow() {
    if (syncInFlight && syncInFlightPromise) return syncInFlightPromise;
    if (syncInFlight) return Promise.resolve();
    syncInFlight = true;
    var hadOperations = false;
    syncInFlightPromise = cartFetchJson(getRoutesRoot() + 'cart.js')
      .then(function (cart) {
        var groups = buildGroups(cart);
        var operations = [];
        var updates = {};
        var productsByGroup = {};

        Object.keys(groups).forEach(function (gid) {
          productsByGroup[gid] = !!(groups[gid] && groups[gid].products && groups[gid].products.length);
        });

        // Nettoyage défensif: toute ligne de frais sans groupe produit correspondant est supprimée.
        (cart.items || []).forEach(function (line, index) {
          if (!isFeeLine(line)) return;
          var feeProps = parseLineProperties(line);
          var feeGroupId = String(feeProps._custom_group_id || feeProps._personalization_group || '');
          if (feeGroupId && productsByGroup[feeGroupId]) return;

          var feeKey = String(line.key || '');
          if (feeKey) updates[feeKey] = 0;
          else updates[String(index + 1)] = 0;
        });

        Object.keys(groups).forEach(function (groupId) {
          var group = groups[groupId];
          if (!group.products.length) return;
          var customGroupId = resolveCustomGroupId(groupId, group);

          // Les options print sont facturées par exemplaire par défaut. Les frais
          // explicitement déclarés "fixed" restent à 1. Cette branche ne touche
          // jamais aux frais flocage/broderie historiques.
          (group.fees || []).filter(isPrintOptionLine).forEach(function (entry) {
            var desiredPrintOptionQty = getPrintOptionQuantityMode(entry) === 'fixed'
              ? 1
              : Math.max(0, toInt(group.totalQty, 0) || 0);
            var currentPrintOptionQty = Math.max(0, toInt(entry && entry.line && entry.line.quantity, 0) || 0);
            if (desiredPrintOptionQty === currentPrintOptionQty) return;
            var printOptionKey = String(entry && entry.lineKey || '');
            if (printOptionKey) updates[printOptionKey] = desiredPrintOptionQty;
            else if (entry && entry.lineNumber) updates[String(entry.lineNumber)] = desiredPrintOptionQty;
          });

          var techniqueKey = getTechniqueKeyForGroup(group);
          if (techniqueKey) {
            var expectedFeeZones = getExpectedFeeZoneKeysForGroup(group);
            var desiredFeeQty = Math.max(0, toInt(group.totalQty, 0) || 0);
            var seenFeeZones = {};
            var techniqueFeeEntries = (group.fees || []).filter(function (entry) {
              return isTechniqueFeeLine(entry);
            });

            techniqueFeeEntries.forEach(function (entry) {
              var feeZoneId = getFeeZoneKey(entry);
              var currentVariantId = String(entry && entry.line && (entry.line.variant_id || entry.line.id) || '');
              var keepZone =
                feeZoneId &&
                expectedFeeZones.indexOf(feeZoneId) >= 0 &&
                !seenFeeZones[feeZoneId];
              if (keepZone) seenFeeZones[feeZoneId] = true;

              var currentQty = Math.max(0, toInt(entry && entry.line && entry.line.quantity, 0) || 0);
              var entryKey = String(entry && entry.lineKey || '');
              if (!keepZone) {
                if (entryKey) updates[entryKey] = 0;
                else if (entry && entry.lineNumber) updates[String(entry.lineNumber)] = 0;
                return;
              }
              operations.push(function () {
                return findBaseFeeVariantForZone(techniqueKey, feeZoneId).then(function (variant) {
                  var desiredVariantId = String(variant && variant.id || '');
                  if (!desiredVariantId) return null;
                  if (desiredVariantId !== currentVariantId) {
                    seenFeeZones[feeZoneId] = true;
                    var removePayload = {};
                    if (entryKey) removePayload[entryKey] = 0;
                    else if (entry && entry.lineNumber) removePayload[String(entry.lineNumber)] = 0;
                    var removal = Object.keys(removePayload).length ? updateLines(removePayload) : Promise.resolve();
                    return removal.then(function () {
                      return addTechniqueFeeLine(desiredVariantId, desiredFeeQty, groupId, customGroupId, techniqueKey, feeZoneId);
                    });
                  }
                  if (currentQty === desiredFeeQty) return null;
                  var qtyPayload = {};
                  if (entryKey) qtyPayload[entryKey] = desiredFeeQty;
                  else if (entry && entry.lineNumber) qtyPayload[String(entry.lineNumber)] = desiredFeeQty;
                  return Object.keys(qtyPayload).length ? updateLines(qtyPayload) : null;
                });
              });
            });

            expectedFeeZones.forEach(function (zoneKey) {
              if (!zoneKey || seenFeeZones[zoneKey]) return;
              operations.push(function () {
                return findBaseFeeVariantForZone(techniqueKey, zoneKey).then(function (variant) {
                  var desiredVariantId = String(variant && variant.id || '');
                  if (!desiredVariantId) return null;
                  return addTechniqueFeeLine(desiredVariantId, desiredFeeQty, groupId, customGroupId, techniqueKey, zoneKey);
                });
              });
            });

            var technicalFeeLines = currentFeeTotals(group);
            if (technicalFeeLines.euroLine) {
              var euroLineKey = String(technicalFeeLines.euroLine.lineKey || '');
              if (euroLineKey) updates[euroLineKey] = 0;
              else if (technicalFeeLines.euroLine.lineNumber) updates[String(technicalFeeLines.euroLine.lineNumber)] = 0;
            }
            if (technicalFeeLines.centLine) {
              var centLineKey = String(technicalFeeLines.centLine.lineKey || '');
              if (centLineKey) updates[centLineKey] = 0;
              else if (technicalFeeLines.centLine.lineNumber) updates[String(technicalFeeLines.centLine.lineNumber)] = 0;
            }

            return;
          }

          var technicalFeeLines = currentFeeTotals(group);
          if (technicalFeeLines.euroLine) {
            var euroKey = String(technicalFeeLines.euroLine.lineKey || '');
            if (euroKey) updates[euroKey] = 0;
            else if (technicalFeeLines.euroLine.lineNumber) updates[String(technicalFeeLines.euroLine.lineNumber)] = 0;
          }
          if (technicalFeeLines.centLine) {
            var centKey = String(technicalFeeLines.centLine.lineKey || '');
            if (centKey) updates[centKey] = 0;
            else if (technicalFeeLines.centLine.lineNumber) updates[String(technicalFeeLines.centLine.lineNumber)] = 0;
          }
        });

        if (Object.keys(updates).length) {
          operations.unshift(function () {
            return updateLines(updates);
          });
        }

        if (!operations.length) return cart;
        hadOperations = true;

        var chain = Promise.resolve();
        operations.forEach(function (run) {
          chain = chain.then(run);
        });

        return chain.then(function () {
          return cartFetchJson(getRoutesRoot() + 'cart.js');
        });
      })
      .then(function (updatedCart) {
        if (hadOperations) publishCartUpdate(updatedCart);
      })
      .catch(function (error) {
        console.error('personalizer-cart-sync error', error);
      })
      .finally(function () {
        syncInFlight = false;
        syncInFlightPromise = null;
      });
    return syncInFlightPromise;
  }

  // Debounce de sync pour éviter d'enchaîner trop de recalculs pendant les updates panier.
  function scheduleSync(delay) {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncFeesNow();
    }, typeof delay === 'number' ? delay : 250);
  }

  // Se branche sur les événements panier du thème (cartUpdate) pour resynchroniser automatiquement.
  function bindListeners() {
    if (!document.querySelector('cart-items, cart-drawer-items')) return;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (!target.matches('.quantity__input')) return;
      scheduleSync(450);
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      var button = target.closest('.quantity__button, cart-remove-button');
      if (!button) return;
      scheduleSync(700);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'personalizer-cart-sync') return;
        scheduleSync(50);
      });
    }
  }

  function boot() {
    bindListeners();
    initialReadyPromise = Promise.resolve();
    window.PersonalizerCartSync = {
      scheduleSync: scheduleSync,
      syncNow: syncFeesNow,
      ready: initialReadyPromise
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
